import React, { useCallback } from 'react';
import * as Mui from '@mui/material';
import { RenderFieldProps } from "@/types/form";

const Upload = ({ field, id, onChange }: RenderFieldProps) => {
  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        // Implement file handling logic here
        onChange(id, file.name);
      }
    },
    [id, onChange]
  );

  return (
    <Mui.FormControl fullWidth margin="normal">
      <Mui.FormLabel>{field.label}</Mui.FormLabel>
      <Mui.Input
        type="file"
        onChange={handleFileChange}
        required={field.required}
      />
    </Mui.FormControl>
  );
};

export default React.memo(Upload);